export default __webpack_public_path__ + "static/higherUseCase-f02b4b8af9cb06cbd861cad5f0fd5e8c.png";